import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Toaster } from 'react-hot-toast';
import MobileNavigation from './components/MobileNavigation';
import MenuSuperior from './components/MenuSuperior';
import HomePage from './pages/Home';
import Programacao from './pages/Programacao';
import Comunicados from './pages/Comunicados';
import Contato from './pages/Contato';
import Ranking from './pages/Ranking';
import Quiz from './pages/Quiz';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Footer from './components/Footer';

function AppContent() {
  const location = useLocation();
  const hideFooter = ['/quiz', '/ranking'].includes(location.pathname);
  const hideMenu = ['/quiz'].includes(location.pathname);

  return (
    <div className="min-h-screen flex flex-col w-full">
      {!hideMenu && <MenuSuperior />}
      
      <AnimatePresence mode="wait">
        <motion.main 
          key={location.pathname}
          className="flex-1 pb-16 md:pb-0 w-full"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
        >
          <Routes location={location}>
            <Route path="/" element={<HomePage />} />
            <Route path="/programacao" element={<Programacao />} />
            <Route path="/comunicados" element={<Comunicados />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/ranking" element={<Ranking />} />
            <Route path="/quiz" element={<Quiz />} />
          </Routes>
        </motion.main>
      </AnimatePresence>
      
      {!hideFooter && <Footer />}
      <MobileNavigation />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Rotas administrativas */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        
        {/* Rotas públicas */}
        <Route path="/*" element={<AppContent />} />
      </Routes>
      <Toaster position="top-right" />
    </Router>
  );
}

export default App;
